var map = {
	"./animal-salon.svg": "d5c4",
	"./art-gallery.svg": "3ecf",
	"./back.svg": "6ca1",
	"./badminton.svg": "273b",
	"./bar.svg": "a783",
	"./baseball.svg": "0f47",
	"./basketball.svg": "c42f",
	"./beauty-salon.svg": "cf29",
	"./botox.svg": "7fae",
	"./building.svg": "7856",
	"./cafe.svg": "a25d",
	"./chiropractor.svg": "71fe",
	"./cinema.svg": "59a0",
	"./clinic.svg": "9d99",
	"./concert.svg": "d756",
	"./convenience-store.svg": "49ab",
	"./dentist.svg": "1c51",
	"./department-store.svg": "b2c7",
	"./education.svg": "3332",
	"./entertainment.svg": "cd75",
	"./event.svg": "1d70",
	"./fnb.svg": "133d",
	"./hair-salon.svg": "7f0c",
	"./hospital.svg": "5620",
	"./ktv.svg": "51e2",
	"./massage.svg": "72a4",
	"./medical.svg": "1209",
	"./merchant.svg": "9084",
	"./nail-salon.svg": "ef11",
	"./night-club.svg": "1570",
	"./office.svg": "efbc",
	"./other.svg": "10d4",
	"./restaurant.svg": "3456",
	"./retail.svg": "5aeb",
	"./seminar.svg": "3831",
	"./service.svg": "032f",
	"./soccer.svg": "7512",
	"./spa.svg": "3117",
	"./supermarket.svg": "05e6",
	"./tattoo.svg": "0b48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37dc";